var staticLocation = require('../static/staticLocation')

var parseUrl = require('../url/parseUrl')

/**
  * 获取地址栏信息
  *
  * @return Object
  */
function locat () {
  return staticLocation ? parseUrl(staticLocation.href) : {}
}

module.exports = locat



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/web/locat.js
// module id = 1948
// module chunks = 106